import PostTag from "./PostTag";

export default function TagGroup({ channelDetails }) {
  const categoryTags = getChannelCategoryTags(channelDetails.category);
  const telegramChannelType = channelDetails.telegram?.telegram_chat_type;

  function getChannelCategoryTags(category) {
    let tags = [];

    if (category?.length) {
      tags = category.map((tag, index) => {
        if (tag.emoji_unicode) {
          return (
            <PostTag
              key={index}
              unicode={tag.emoji_unicode}
              label={tag?.display_name}
              className="mr-2 mt-2"
            />
          );
        } else if (tag.media?.url) {
          return (
            <PostTag
              key={index}
              icon={tag.media.url}
              label={tag?.display_name}
              className="mr-2 mt-2"
            />
          );
        }
      });
    }

    return tags;
  }

  return (
    <div className="flex items-center flex-wrap mt-4">
      {categoryTags}
      <PostTag
        icon={"/assets/social-icons/telegram-original.svg"}
        label={`Telegram ${telegramChannelType}`}
        className="mr-2 mt-2 capitalize"
      />
    </div>
  );
}
